import { ProfileTrade, ProfileTradeHistoryItem } from 'types/interfaces/profile';

/**
 * The items of a trade the grid shows. With a card filter active the backend
 * returns every item of each matching trade and flags the ones that satisfy
 * the filter; only those render. With no filter every item is flagged true.
 * A backend that predates the flag sends none, and every item shows as before.
 */
export const visibleTradeItems = (trade: ProfileTrade): ProfileTradeHistoryItem[] =>
  trade.items.filter((item) => item.matchesFilters !== false);

/** The "{n} Cards" header: the cards actually rendered across the loaded trades. */
export const countVisibleCards = (trades: ProfileTrade[]): number =>
  trades.reduce((sum, trade) => sum + visibleTradeItems(trade).length, 0);
